module.exports = __webpack_public_path__ + "media/images/icons/icon_check_white-1efbb276ec025a224570ddde5c1740fe.svg";